import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    resultCust: {},
    blockRoomData: {},
    result: {},
    eventss: [],
    apiLoading: {
      resultCustLoading: false,
      blockRoomData: false,
      resultLoading: false,
    },
    handleTrigger: false
};

const calenderSlice = createSlice({
  name: "calender",
  initialState: initialState,
  reducers: {
    handleTriggerSuccess: (state, action) => {
      state.handleTrigger = true;
    },
    handleTriggerFailed: (state, action) => {
      state.handleTrigger = false;
    },
    resultCustSuccess: (state, action) => {
      state.resultCust = action.payload;
    },
    resultCustFailed: (state, action) => {
      state.resultCust = {};
    },
    blockRoomDataSuccess: (state, action) => {
      state.blockRoomData = action.payload;
    },
    blockRoomDataFailed: (state, action) => {
      state.blockRoomData = {};
    },
    resultSuccess:  (state, action) => {
      state.result = action.payload;
    },
    resultFailed:  (state, action) => {
      state.result = {};
    },
    eventssSuccess:  (state, action) => {
      state.eventss = action.payload;
    },
    eventssFailed:  (state, action) => {
      state.eventss = {};
    },
    apiLoadingSuccess: (state, action) => {
      state.apiLoading = {...state.apiLoading, [action.payload]: true }
    },
    apiLoadingFailed: (state, action) => {
      state.apiLoading = {...state.apiLoading, [action.payload]: false }
    }
    
  },
});

export const {
  resultCustSuccess,
  resultCustFailed,
  blockRoomDataSuccess,
  blockRoomDataFailed,
  resultSuccess,
  resultFailed,
  eventssSuccess,
  eventssFailed,
  apiLoadingSuccess,
  apiLoadingFailed,
  handleTriggerSuccess,
  handleTriggerFailed
} = calenderSlice.actions;

export default calenderSlice.reducer;
